import { render, staticRenderFns } from "./TriggerList.vue?vue&type=template&id=55526b84&scoped=true&"
import script from "./TriggerList.vue?vue&type=script&lang=js&"
export * from "./TriggerList.vue?vue&type=script&lang=js&"
import style0 from "./TriggerList.vue?vue&type=style&index=0&id=55526b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55526b84",
  null
  
)

export default component.exports